var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 47,
    viewBox: "0 0 233 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 233,
    height: 47
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 47,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.786078,
    width: 90.2028,
    height: 90.2028,
    transform: "matrix(0.786078 -0.618127 0.786078 0.618127 -18.8318 62.3692)",
    stroke: "#D4C094",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.78581,
    width: 90.1931,
    height: 90.1931,
    transform: "matrix(0.78581 -0.618468 0.78581 0.618468 12.8382 62.3693)",
    stroke: "#D4C094",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.78581,
    width: 90.1931,
    height: 90.1931,
    transform: "matrix(0.78581 -0.618468 0.78581 0.618468 44.5077 62.3693)",
    stroke: "#D4C094",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.78581,
    width: 90.1931,
    height: 90.1931,
    transform: "matrix(0.78581 -0.618468 0.78581 0.618468 76.1776 62.3693)",
    stroke: "#D4C094",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.78581,
    width: 90.1931,
    height: 90.1931,
    transform: "matrix(0.78581 -0.618468 0.78581 0.618468 107.848 62.3693)",
    stroke: "#D4C094",
    strokeOpacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footer-bg.d4b7dbb414eed75da2549c6d2b5d1b00.svg";
export { ForwardRef as ReactComponent };